"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _AccordionCommon = _interopRequireDefault(require("./AccordionCommon"));

var _Render = _interopRequireDefault(require("./Render"));

var _utils = require("../../../utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};
/* eslint-disable @typescript-eslint/prefer-optional-chain */

/* eslint-disable @typescript-eslint/no-require-imports */


var SuccessIcon = require('@tencent/ixd-icons-react/dist').SuccessIcon;

function BrandEquity(props) {
  var _a = props || {},
      style = _a.style,
      _b = _a.configuration,
      configuration = _b === void 0 ? [] : _b;

  var _c = (0, _react.useState)(0),
      activeTab = _c[0],
      setActiveTab = _c[1];

  var _d = (0, _react.useState)(false),
      play = _d[0],
      setPlay = _d[1];

  if (!configuration || configuration.length === 0) {
    return null;
  } // const autoSwitchTimeout = 10 * 1000; // 此时间须与样式设定的 progressBar 动画时间一致


  var onChangeTab = function onChangeTab(index) {
    setPlay(true);
    setActiveTab(index); // window.recordBehavior &&
    //   window.recordBehavior.reportEvent('click_new_home_why_tencent_cloud', { ext1: index });
  }; // const autoRun = () => {
  //   if (play) return;
  //   setActiveTab((activeTab + 1) % configuration.length);
  // };

  /*  useEffect((): any => {
    const timer = true
      ? setTimeout(() => {
          autoRun();
        }, autoSwitchTimeout)
      : null;
    return () => timer && clearTimeout(timer);
  }, [activeTab]);*/
  // 移动端组件控制

  /*  function FlexAccordion(props: any) {
    const { configuration = [] } = props;
    return (
      <div className="brand-equity-container__mo">
        <div className="intl-scene-tab-slider">
          <div className="intl-scene-tab-slider-inner">
            <div className="intl-scene-tab-slider-scroll">
              <ul className="intl-scene-tab-slider-list">
                {configuration.map((item: any, index: any) => (
                  <li className="intl-scene-tab-slider-item" key={`banner_m_${index}`}>
                    <div className="home-scene-tab-card">
                      <div className="home-scene-tab-card-object">
                        <img className="home-scene-tab-card-img" src={item.img} alt="" />
                      </div>
                      <div className="home-scene-tab-card-main">
                        <h3 className="home-scene-tab-card-title">{item.title}</h3>
                        <p className="home-scene-tab-card-desc">{item.longDesc}</p>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }*/


  return /*#__PURE__*/_react["default"].createElement("div", {
    style: (0, _typeof2["default"])(style) === 'object' ? style : {},
    className: 'brand-equity-container'
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: 'brand-equity-container__content'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'brand-equity-container-pc'
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: 'brand-equity__container'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'brand-equity__container-left'
  }, configuration.map(function (_item, index) {
    var _a = (0, _utils.fomateFileData)(_item === null || _item === void 0 ? void 0 : _item.iconPic),
        url = _a.url,
        _b = _a.alt,
        alt = _b === void 0 ? '' : _b;

    return /*#__PURE__*/_react["default"].createElement("div", __assign({
      className: (0, _classnames["default"])('brand-equity__container-left-list', {
        active: activeTab === index,
        play: play
      }),
      onClick: function onClick() {
        return onChangeTab(index);
      },
      key: index
    }, _item.extendProps || {}), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'left-content'
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: 'span'
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: url,
      alt: alt
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'right-content'
    }, /*#__PURE__*/_react["default"].createElement("h4", {
      className: 'scene-tabs-h4'
    }, _item.title), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('hide', {
        show: activeTab === index
      })
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('scene-tabs-description')
    }, _item.shortDesc))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "item-process"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "item-process-bar"
    })));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'brand-equity__container-right'
  }, configuration.map(function (item, index) {
    var _a = item || {},
        title = _a.title,
        img = _a.img,
        titleRight = _a.titleRight,
        contentRight = _a.contentRight,
        tipList = _a.tipList,
        titleSmall = _a.titleSmall,
        descList = _a.descList,
        signTxt = _a.signTxt,
        onCallback = _a.onCallback,
        more = _a.more,
        moreHref = _a.moreHref,
        tabRightDescExtendProps = _a.tabRightDescExtendProps,
        tabRightBtnExtendProps = _a.tabRightBtnExtendProps;

    var _b = (0, _utils.fomateFileData)(img),
        url = _b.url,
        _c = _b.alt,
        alt = _c === void 0 ? '' : _c;

    return /*#__PURE__*/_react["default"].createElement("section", {
      key: index,
      className: (0, _classnames["default"])('brand-equity__container-right__section', {
        active: activeTab === index
      })
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'brand-equity__container-right-wrap'
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: 'meng-layer'
    }), /*#__PURE__*/_react["default"].createElement("img", {
      key: index,
      src: url,
      className: (0, _classnames["default"])('brand-equity__container-right-image'),
      alt: alt
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'attach-img-content'
    }, /*#__PURE__*/_react["default"].createElement("strong", null, titleRight ? titleRight : title), /*#__PURE__*/_react["default"].createElement("p", {
      className: 'contentRight'
    }, contentRight, " \xA0\xA0\xA0", /*#__PURE__*/_react["default"].createElement("a", __assign({
      style: {
        color: '#78FFC7'
      },
      href: moreHref
    }, tabRightDescExtendProps || {}), more)), /*#__PURE__*/_react["default"].createElement("ul", null, tipList === null || tipList === void 0 ? void 0 : tipList.map(function (tipItem, index) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: index
      }, tipItem);
    })))), /*#__PURE__*/_react["default"].createElement("h4", {
      className: 'scene-tabs-h4-right'
    }, titleSmall ? titleSmall : title), /*#__PURE__*/_react["default"].createElement("ul", {
      className: 'brand-equity__left__ul'
    }, descList === null || descList === void 0 ? void 0 : descList.map(function (item, index) {
      var txt = (item || {}).txt;
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: index,
        className: 'brand-equity__left__ul__li'
      }, /*#__PURE__*/_react["default"].createElement(SuccessIcon, null), txt);
    })), signTxt && /*#__PURE__*/_react["default"].createElement("button", __assign({
      className: 'brand-equity-sign',
      val: signTxt,
      // style={{
      //   backgroundImage: `url(https://staticintl.cloudcachetci.com/cms/backend-cms/ydrH809_btn.png)`,
      //   backgroundRepeat: 'no-repeat',
      // }}
      onClick: function onClick() {
        return onCallback && onCallback();
      }
    }, tabRightBtnExtendProps || {}), signTxt));
  }))))), /*#__PURE__*/_react["default"].createElement("section", {
    className: 'brand-equity-container__content--mo'
  }, /*#__PURE__*/_react["default"].createElement(_AccordionCommon["default"] // defaultExplore={true}
  , {
    // defaultExplore={true}
    className: 'accordion-card-less',
    render: function render(props) {
      return /*#__PURE__*/_react["default"].createElement(_Render["default"], {
        item: props
      });
    },
    configuration: configuration
  })));
}

var _default = BrandEquity;
exports["default"] = _default;